export const ru = {
    ad: 'Объявление',
    'ad-description':
        'Форма создания нового объявления, где вы сможете настроить его',
    add: 'Добавить',
    campaign: 'Кампанию',
    'campaign-description':
        'От типа кампании зависит, где будут показываться объявления',
    group: 'Группу',
    'group-description':
        'Пустая группа, в которой можно создать до 50 новых объявлений',
    phrase: 'Ключевые фразы',
    'phrase-description':
        'Подборщик ключевых слов, который поможет найти нужные слова'
};
